import { render, staticRenderFns } from "./UnitGroupPeople.vue?vue&type=template&id=d606db34&"
import script from "./UnitGroupPeople.vue?vue&type=script&lang=js&"
export * from "./UnitGroupPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports